import {Alert, Button, closeCurrentDialog, showNotification} from 'platform/components';
import {HStack, VStack} from 'platform/foundation';

import {usePatchCoreExchangeRmaRequestMutation} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

interface RmaRequestDialogProps extends RequiredTestIdProps {
  coreExchangeId: string;
  onSaved: VoidFunction;
}

export function RmaRequestDialog(props: RmaRequestDialogProps) {
  const [patchRmaRequest, {isLoading}] = usePatchCoreExchangeRmaRequestMutation();

  const handleSendRequest = () =>
    patchRmaRequest({coreExchangeId: props.coreExchangeId})
      .unwrap()
      .then(() => {
        showNotification.success(i18n.t('general.notifications.successfullyUpdated'));
        props.onSaved();
        closeCurrentDialog();
      })
      .catch(handleApiError);

  return (
    <VStack spacing={4}>
      <Alert
        type="inline"
        variant="warning"
        message={i18n.t('entity.warehouse.labels.coreExchangeRmaRequestWarning')}
        data-testid={suffixTestId('warning', props)}
      />
      <HStack spacing={2} justify="flex-end">
        <Button
          title={i18n.t('general.actions.discard')}
          variant="secondary"
          onClick={closeCurrentDialog}
          data-testid={suffixTestId('actions.discard', props)}
        />
        <Button
          title={i18n.t('entity.carisServiceRequest.actions.sendRequest')}
          variant="primary"
          isLoading={isLoading}
          onClick={handleSendRequest}
          data-testid={suffixTestId('actions.confirm', props)}
        />
      </HStack>
    </VStack>
  );
}
